import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderCreationStatusModal', {
  defaultErrorTitle: 'Ha ocurrido un error',
  backButton: 'Volver'
});
